module.exports = __webpack_public_path__ + "static/media/mentor-1.9645aee1.png";